export default __webpack_public_path__ + "710e54a05a77d8cdb129bc429234c96b.svg";